import { render, staticRenderFns } from "./UserPermissionsView.html?vue&type=template&id=0bf89b92&scoped=true&"
import script from "./UserPermissionsView.js?vue&type=script&lang=js&"
export * from "./UserPermissionsView.js?vue&type=script&lang=js&"
import style0 from "./UserPermissionsView.scss?vue&type=style&index=0&id=0bf89b92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf89b92",
  null
  
)

export default component.exports